import styled from "styled-components";

export const RegistrationWrapper = styled.div`
  .registartionHeader {
    position: fixed;
    top: 72px;
    left: 0;
    right: 0;
    width: 100%;
    -webkit-transition: all 0.3s ease-out 0s;
    transition: all 0.3s ease-out 0s;
    background: var(--white);
    padding-top: 24px;
    padding-bottom: 20px;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
    z-index: 190;
    border-top: 1px solid var(--border);
    line-height: 1;
    padding-left: 1.5rem;
    padding-right: 1.5rem;

    @media (max-width: 767px) {
      & {
        padding-left: 1rem;
        padding-right: 1rem;
        & > div {
          font-size: 20px;
        }
      }
    }
  }
`;
export const RegContentWrapper = styled.div`
  padding-top: 160px;
  padding-bottom: 25px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  .RegContentContainer {
    background-color: var(--white);
    border-radius: 10px;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
    padding: 40px;
    min-height: calc(100vh - 185px);
    .stepsBtns {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      .nextStepBtn {
        margin-right: 0;
        margin-left: auto;
        body.rtl & {
          margin-right: auto;
          margin-left: 0;
        }
      }
    }
  }
  .pBarContainer {
    padding: 40px 80px 70px 80px;
    border-bottom: 1px solid var(--border);
  }
  // .formDataContainer{
  // 	padding: 20px;
  // }
  .RSPBprogressBar {
    height: 3px;
    line-height: 1;
    border-radius: 10px;
    position: relative;
    background-color: var(--border);
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 0;

    .RSPBstep {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      z-index: 0;
      margin-top: 28px;
      // position: absolute;
      // transform: translateX(-50%);
      // transition-property: all;
      // transition-timing-function: ease;
      &:first-child {
        margin-left: -70px;
      }
      &:nth-child(4) {
        margin-right: -70px;
      }
    }

    .RSPBprogressBarText {
      color: white;
      font-size: 10px;
      // position: absolute;
      // top: 50%;
      // left: 50%;
      // transform: translate(-50%, -50%);
    }
    .RSPBprogression {
      position: absolute;
      transition: width 0.3s ease;
      left: 0;
      top: 0;
      bottom: 0;
      border-radius: 10px;
      background: rgba(0, 116, 217, 0.8);
      z-index: -1;
    }
    .indexedStep {
      color: white;
      width: 140px;
      // height: 20px;
      font-size: 12px;

      border-radius: 50%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-size: 14px;
      color: var(--grey);
    }
    .indexedCount {
      background-color: var(--white);
      border-radius: 50%;
      width: 38px;
      height: 38px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 3px solid var(--outlineC);
    }
    .accomplished .indexedCount {
      background-color: var(--themeColor);
      color: var(--white);
      border: 3px solid var(--themeColor);
    }
    .stepTitle {
      width: 100%;
      margin-top: 15px;
      font-family: var(--semiBold);
    }
    .accomplished .stepTitle {
      color: var(--themeColor);
    }

    // .indexedStep.accomplished {
    // 	background-color: rgba(0, 116, 217, 1);
    // }
  }
  @media (max-width: 767px) {
    & {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }
  @media (max-width: 991px) {
    .RegContentContainer {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
  @media (max-width: 767px) {
    .RegContentContainer {
      padding-left: 16px;
      padding-right: 16px;
    }
  }
  @media (max-width: 400px) {
    .RegContentContainer {
      padding-left: 8px;
      padding-right: 8px;
    }
  }
`;
export const ProgressBarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  position: relative;
  padding-left: 130px;
  body.rtl & {
    padding-left: 0;
    padding-right: 130px;
  }

  /* Line connecting the steps */
  .progress-line {
    position: absolute;
    top: 33px;
    width: calc(100% - 280px);
    height: 4px;
    background-color: #e0e0e0;
    z-index: 1;
  }

  .progress-fill {
    height: 100%;
    background-color: var(--themeColorSecondary);
    transition: width 0.3s ease-in-out;
  }

  /* Individual step */
  .progress-step {
    display: flex;
    flex-direction: column;
    align-items: start;
    z-index: 2;
    width: 166px;
    /* text-align: left; */
    .stepCountTitle {
      font-size: 12px;
      color: var(--lightGrey2);
      font-family: var(--regular);
      body.rtl & {
        font-family: var(--arRegular);
      }
    }
    .stepCountStatus {
      color: var(--lightGrey2);
    }

    .step-number {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      background-color: var(--white);
      display: flex;
      justify-content: center;
      align-items: center;
      .stepNumberInner {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 38px;
        height: 38px;
        border-radius: 50%;
        background-color: var(--border);
        border: 1px solid var(--border);
        span {
          display: flex;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background-color: var(--border);
          align-items: center;
          justify-content: center;
        }
      }
      @media (max-width: 767px) {
        & {
          width: 40px;
          height: 40px;
          .stepNumberInner {
            width: 28px;
            height: 28px;
            span {
              width: 14px;
              height: 14px;
            }
          }
        }
      }
    }
    .step-label {
      font-size: 14px;
      color: #666;
    }
    &.current {
      .stepCountStatus {
        color: var(--lightGrey);
      }
      .step-number {
        background-color: var(--white);
        .stepNumberInner {
          background-color: var(--white);
          border: 1px solid var(--lightGrey);
          span {
            background-color: var(--lightGrey);
          }
        }
      }
    }
    &.done {
      .stepCountStatus {
        color: var(--themeColorSecondary);
      }
      .step-number {
        background-color: var(--white);
        .stepNumberInner {
          background-color: var(--themeColorSecondary);
          border: 1px solid var(--themeColorSecondary);
          span {
            background-color: var(--themeColorSecondary);
          }
        }
      }
    }
    &.current {
      .stepCountStatus {
        color: var(--themeColorSecondary);
      }
    }
  }
  @media (max-width: 1199px) {
    padding-left: 60px;
    .progress-line {
      width: calc(100% - 190px);
    }
    body.rtl & {
      padding-left: 0;
      padding-right: 60px;
      .progress-line {
        width: calc(100% - 190px);
      }
    }
  }
  @media (max-width: 991px) {
    & {
      padding-left: 0;
      .progress-line {
        left: 30px;
        width: calc(100% - 150px);
      }
      body.rtl & {
        padding-left: 0;
        padding-right: 0px;
        .progress-line {
          right: 30px;
          width: calc(100% - 150px);
        }
      }
    }
  }
  @media (max-width: 767px) {
    & {
      .progress-line {
        /* left: 30px; */
        width: calc(100% - 160px);
        top: 19px;
      }
      body.rtl & {
        /* padding-left: 0;
                padding-right: 0px; */
        .progress-line {
          /* right: 30px; */
          width: calc(100% - 160px);
        }
      }
    }
    .stepTitle {
      font-size: 14px;
    }
  }
  @media (max-width: 640px) {
    & {
      .progress-line {
        width: calc(100% - 130px);
      }
      body.rtl & {
        .progress-line {
          width: calc(100% - 130px);
        }
      }
    }
  }
  @media (max-width: 499px) {
    & {
      .progress-line {
        left: 0px;
        width: calc(100% - 70px);
      }
      body.rtl & {
        .progress-line {
          width: calc(100% - 100px);
        }
      }
    }
  }
  @media (max-width: 400px) {
    & {
      gap: 5px;
      .progress-line {
        width: calc(100% - 40px);
      }
      /* body.rtl & {
        .progress-line {
          width: calc(100% - 40px);
        }
      } */
    }
  }
  @media (max-width: 350px) {
    & {
      gap: 3px;
      .progress-line {
        width: calc(100% - 10px);
      }
      /* body.rtl & {
        .progress-line {
          width: calc(100% - 10px);
        }
      } */
      .stepTitle {
        font-size: 13px;
      }
      .stepCountStatus {
        font-size: 13px;
      }
    }
  }
`;

export const StepsWrapper = styled.div`
  padding-top: 40px;

  .profileAvatarContainer {
    display: flex;
    width: 100%;
    height: fit-content;
    padding: 24px 0px 0px 0px;
    /* border-bottom: 1px solid var(--borderLight); */
  }
  .profileAvatarImg {
    position: relative;
    display: flex;
    width: 100%;
    align-items: center;
    .profileAvatarImgContainer {
      width: fit-content;
      position: relative;
      min-width: 78px;
      max-width: 78px;
      height: 78px;
    }
    .profileAvatar {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
    .profileUserNameWrapper {
      padding-left: 20px;
      body.rtl & {
        padding-left: 0;
        padding-right: 25px;
      }
    }
  }
  @media (max-width: 767px) {
    padding-top: 30px;
    .stepsMainTitle {
      font-size: 20px;
    }
    .profileUserName {
      font-size: 20px;
    }
    .profileAvatarContainer {
      padding-top: 12px;
      .profileAvatarImg {
        flex-wrap: wrap;
        .profileUserNameWrapper {
          padding-left: 0;
          width: 100%;
        }
        .profileUserNameWrapper {
          margin-top: 15px;
        }
      }
    }
  }
`;
export const ProfileRejectReview = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  flex-wrap: wrap;
  .RegContentPRR {
    display: flex;
    width: 100%;
    max-width: 770px;
    gap: 30px;
    img {
      min-width: 202px;
      max-width: 202px;
      height: 161px;
    }
  }
`;

/*
// Styled Components for Progress Bar
export const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0;
`;

export const ProgressTrack = styled.div`
  position: relative;
  height: 10px;
  background: #e0e0e0;
  border-radius: 5px;
  flex-grow: 1;
  margin: 0 10px;
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background: var(--themeColor, #4caf50);
  width: ${(props) => props.percentage}%;
  transition: width 0.3s ease-in-out;
`;

export const StepMarker = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;
  background: ${(props) => (props.active ? "#4caf50" : "#e0e0e0")};
  border-radius: 50%;
  top: -5px;
  left: ${(props) => props.position}%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: white;
  font-weight: bold;
`;

export const StepLabel = styled.div`
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
  font-weight: ${(props) => (props.active ? "bold" : "normal")};
  color: ${(props) => (props.active ? "var(--themeColor, #4caf50)" : "#808080")};
`;

export const StepContainer = styled.div`
  width: 25%;
  text-align: center;
`;

export const StepWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
*/
